import React from 'react'
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import styles from "../Home.module.css"
import picCarusel2 from '../../../assets/img/pictures/picCarusel2.JPG'
import picCarusel3 from '../../../assets/img/pictures/picCarusel3.JPG'
import picCarusel4 from '../../../assets/img/pictures/picCarusel4.JPG'
import picCarusel5 from '../../../assets/img/pictures/picCarusel5.jpg'
import picCarusel6 from '../../../assets/img/pictures/picCarusel6.JPG'
import picCarusel7 from '../../../assets/img/pictures/picCarusel7.JPG'
import arrow from '../../../assets/img/arrow.svg'


const CustomRightArrow = ({ onClick, ...rest }) => {
    const {
        onMove,
        carouselState: { currentSlide, deviceType }
    } = rest;
    return <button className={styles.customRightArrow} onClick={() => onClick()} ><img src={arrow} /> </button >
};
const CustomLeftArrow = ({ onClick, ...rest }) => {
    const {
        onMove,
        carouselState: { currentSlide, deviceType }
    } = rest;
    return <button className={styles.customLeftArrow} onClick={() => onClick()} ><img src={arrow} /> </button >
};

const PhotoCarousel = () => {
    const images = [picCarusel2, picCarusel3, picCarusel4, picCarusel5, picCarusel6, picCarusel7]
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            paritialVisibilityGutter: 60
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
            paritialVisibilityGutter: 50
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            paritialVisibilityGutter: 30
        }
    };
    return (
        <>
            <Carousel
                customRightArrow={<CustomRightArrow />}
                customLeftArrow={<CustomLeftArrow />}
                swipeable={true}
                draggable={true}
                infinite={true}
                autoPlay={true}
                //autoPlay={this.props.deviceType !== "mobile" ? true : false}
                autoPlaySpeed={4000}
                keyBoardControl={true}
                //   deviceType={deviceType}
                responsive={responsive}
            >
                {images.map((img, i) => {
                    return (
                        <div className={styles.photoSliderItem}>
                            <img key={i} src={img} />
                        </div>
                    )
                })}
            </Carousel>
        </>
    )

}
export default PhotoCarousel